import {LoginPage} from './login-page';
export function ResetPasswordPage(_props: any) { return <LoginPage />; }
